import { Modal } from 'bootstrap'
import moment from 'moment'
import { popoverInitialise } from '../General/utils'

const initialise = () => {
	const mailshotTable = new JSTable('#MailshotTable', {
		columns: [
			{
				select: 0,
				sort: 'desc'
			},
			{
				select: 3,
				render(cell: HTMLTableCellElement) {
					const data = cell.innerHTML
					if (data !== '') {
						return moment(data).format('DD/MM/YYYY')
					}
					return ''
				}
			},
			{
				select: 5,
				sortable: false
			}
		],
		labels: {
			loading: 'Loading...',
			noRows: 'No data available in table'
		},
		perPage: 20
	})
	mailshotTable.on('update', () => {
		popoverInitialise()
	})
	const btnAddMailshotModal = document.querySelector(
		'.btnAddMailshotModal'
	) as HTMLButtonElement
	if (btnAddMailshotModal != null) {
		btnAddMailshotModal.addEventListener('click', () => {
			const addMailshotModalDiv = document.querySelector(
				'.AddMailshotModal'
			) as HTMLFormElement
			const addMailshotModal = new Modal(addMailshotModalDiv!, {
				backdrop: true,
				keyboard: true
			})
			addMailshotModal.show()
		})
	}
}
window.addEventListener('load', () => {
	initialise()
})
